<template>
    <div>
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">Dashboard for Downloads</h1>
                    </div>
                    <span class="badge bg-info">
                        Current document and profile download statistics are cached data and will be refreshed
                        every 5 minutes on user triggered basis.
                    </span>
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>

        <!-- for the stat left 1st column -->
        <div class="row">
            <section class="col-lg-6">
                <div class="card card-outline card-primary" ref="prevEncode">
                    <div class="card-header">
                        <h3 class="card-title">Documents Download Statistics {{ currentDay }}
                        <span class="badge bg-info">Will be refreshed after 5 minutes</span></h3>
                    </div>
                    <div class="card-body">
                        <div class="tab-content p-0">
                            <bar-chart id="bar"
                                       :data="chartDataLatestDocumentDownload.rows"
                                       xkey="region"
                                       ykeys='["count"]'
                                       resize="true"
                                       labels='["Total"]'
                                       bar-colors='["#3548ea"]'
                                       xLabelAngle="35"
                                       barRatio="0.5"
                                       grid="true"
                                       grid-text-weight="bold"></bar-chart>
                        </div>
                    </div>
                </div>
                
                <div class="card card-outline card-primary" ref="prevEncode">
                    <div class="card-header">
                        <h3 class="card-title">Documents Download Statistics {{ currentMonth }}
                        <span class="badge bg-info">Will be refreshed after 5 minutes</span></h3>
                    </div>
                    <div class="card-body">
                        <div class="tab-content p-0">
                            <bar-chart id="bar2"
                                       :data="chartDataLatestDocumentDownloadMonth.rows"
                                       xkey="region"
                                       ykeys='["count"]'
                                       resize="true"
                                       labels='["Total"]'
                                       bar-colors='["#3548ea"]'
                                       xLabelAngle="35"
                                       barRatio="0.5"
                                       grid="true"
                                       grid-text-weight="bold"></bar-chart>
                        </div>
                    </div>
                </div>
            </section>
            <!-- for the stat right 2nd column -->
            <section class="col-lg-6">
                
                <div class="card card-outline card-success" ref="currentLink">
                    <div class="card-header">
                        <h3 class="card-title">
                            Profile Download Statistics {{ currentDay }}
                            <span class="badge bg-info">Will be refreshed after 5 minutes</span>
                        </h3>
                        <!-- <div class="card-tools">
                            <button type="button" class="btn btn-default btn-sm btn-tool" title="Refresh Linked Statistics" data-card-widget="" @click="loadLinkedCurrent()">Refresh</button>
                        </div> -->
                    </div>
                    <div class="card-body">
                        <div class="tab-content p-0">
                            <bar-chart id="bar3"
                                       :data="chartDataLatestProfile.rows"
                                       xkey="region"
                                       ykeys='["count"]'
                                       resize="true"
                                       labels='["Total"]'
                                       bar-colors='["#3548ea"]'
                                       xLabelAngle="35"
                                       barRatio="0.5"
                                       grid="true"
                                       grid-text-weight="bold"></bar-chart>
                        </div>
                    </div>
                </div>

                <div class="card card-outline card-success" ref="currentLink">
                    <div class="card-header">
                        <h3 class="card-title">
                            Profile Download Statistics {{ currentMonth }}
                            <span class="badge bg-info">Will be refreshed after 5 minutes</span>
                        </h3>
                        <!-- <div class="card-tools">
                            <button type="button" class="btn btn-default btn-sm btn-tool" title="Refresh Linked Statistics" data-card-widget="" @click="loadLinkedCurrent()">Refresh</button>
                        </div> -->
                    </div>
                    <div class="card-body">
                        <div class="tab-content p-0">
                            <bar-chart id="bar4"
                                       :data="chartDataLatestProfileMonth.rows"
                                       xkey="region"
                                       ykeys='["count"]'
                                       resize="true"
                                       labels='["Total"]'
                                       bar-colors='["#3548ea"]'
                                       xLabelAngle="35"
                                       barRatio="0.5"
                                       grid="true"
                                       grid-text-weight="bold"></bar-chart>
                        </div>
                    </div>
                </div>
               
            </section>
        </div>
    </div>
</template>
<script>
    import {
        authHeader,
        responseCheck,
        LogURL,
        getWithExpiry,
        setWithExpiry,
    } from "../helper";
    import Raphael from "raphael/raphael";
    global.Raphael = Raphael;
    import { BarChart } from "vue-morris";
    import instance from "../helper/http";
    export default {
        data() {
            return {
                monthNames: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                ],
                currentMonth: "",
                currentDay: new Date().toLocaleDateString(),
                //currentYear: new Date().getFullYear(),
                //previousYear: new Date().getFullYear() - 1,
                chartDataLatestDocumentDownload: {
                    columns: ["region", "count"],
                    rows: [],
                },
                chartDataLatestProfile: {
                    columns: ["region", "count"],
                    rows: [],
                },
                chartDataLatestDocumentDownloadMonth: {
                    columns: ["region", "count"],
                    rows: [],
                },
                chartDataLatestProfileMonth: {
                    columns: ["region", "count"],
                    rows: [],
                }
                
            };
        },
        components: {
            BarChart,
        },
        mounted() {
            this.loadCurrentProfile();
            this.loadCurrentDocument();
            this.loadCurrentDocumentMonth();
            this.loadCurrentProfileMonth();
            let d = new Date();
            this.currentMonth = this.monthNames[d.getMonth()];
        },
        methods: {
            loadCurrentProfile() {
                let currentProfile = getWithExpiry("latest-profile-download");
                if (currentProfile) {
                    this.chartDataLatestProfile.rows = currentProfile;
                    return;
                }
                instance
                    .get(LogURL + "dailyprofilestats", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.chartDataLatestProfile.rows = response.data.data;
                        setWithExpiry("latest-profile-download", response.data.data, 14400000, false);
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            loadCurrentDocument() {
                let currentDocument = getWithExpiry("latest-document-download");
                if (currentDocument) {
                    this.chartDataLatestDocumentDownload.rows = currentDocument;
                    return;
                }
                instance
                    .get(LogURL + "dailydocumentstats", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.chartDataLatestDocumentDownload.rows = response.data.data;
                        setWithExpiry("latest-document-download", response.data.data, 14400000, false);
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            loadCurrentProfileMonth() {
                let currentProfile = getWithExpiry("latest-profile-download-monthly");
                if (currentProfile) {
                    this.chartDataLatestProfileMonth.rows = currentProfile;
                    return;
                }
                instance
                    .get(LogURL + "monthlyprofilestats", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.chartDataLatestProfileMonth.rows = response.data.data;
                        setWithExpiry("latest-profile-download-monthly", response.data.data, 14400000, false);
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            loadCurrentDocumentMonth() {
                let currentDocument = getWithExpiry("latest-document-download-monthly");
                if (currentDocument) {
                    this.chartDataLatestDocumentDownloadMonth.rows = currentDocument;
                    return;
                }
                instance
                    .get(LogURL + "monthlydocumentstats", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.chartDataLatestDocumentDownloadMonth.rows = response.data.data;
                        setWithExpiry("latest-document-download-monthly", response.data.data, 14400000, false);
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            }
        },
    };
</script>